import React from 'react';
import Divider from 'material-ui/Divider';
import TextField from 'material-ui/TextField';

const ResetPasswordForm = props => {
    return (
        <div className="inputPageContainer">
            <div className="inputPage">
                <h1>Password Reset</h1>
                <form onSubmit={props.handleSubmit}>
                    <TextField
                        hintText="New Password"
                        underlineShow={false}
                        className="inputRow"
                        fullWidth={true}
                        type="password"
                        name="newPassword"
                        value={props.newPassword}
                        onChange={props.handleChange}
                    />
                    <Divider />
                    <TextField
                        hintText="Repeat New Password"
                        underlineShow={false}
                        className="inputRow"
                        fullWidth={true}
                        type="password"
                        name="newPasswordRepeat"
                        value={props.newPasswordRepeat}
                        onChange={props.handleChange}
                    />
                    <Divider />
                    <button className="pink">Reset</button>
                </form>
                <p className="errorMessage">{props.errMsg}</p>
            </div>
        </div>
    );
}

export default ResetPasswordForm;
